export default __webpack_public_path__ + "static/media/register.580aaad5.jpg";